import { render, staticRenderFns } from "./PropertyAlertEdit.vue?vue&type=template&id=9e140402&"
import script from "./PropertyAlertEdit.vue?vue&type=script&lang=js&"
export * from "./PropertyAlertEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports